export default {
  init() {
    // JavaScript to be fired on all pages

    /**
     * Opens mobile navgaiton draw
     */
    $('.hamburglar').click(function () {
      $(this).toggleClass('open');
      $('.mobile-nav').toggleClass('open');
      $('.page-wrap').toggleClass('open');
      $('.btn-enter-home').toggleClass('d-none');
      $('body').toggleClass('scroll-fix');
    });

    /**
     * Toggles Moible navigation sub menus
     */
    $(document).on('click', '.toggle-menu', function () {
      $(this).prev('.sub-menu').slideToggle();
    });

    // Check if an elemnt is in viewport
    function isScrolledIntoView(elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();

      var elemTop = $(elem).offset().top;
      var elemBottom = elemTop + $(elem).height();

      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }

    // Animate stats when in viewport
    $(window).on('scroll load', function () {
      $('.number.animate-once').each(function () {
        let total = $(this).data('count');
        if (isScrolledIntoView(this) === true) {
          $(this)
            .prop('Counter', 0)
            .animate(
              {
                Counter: total,
              },
              {
                duration: 1600,
                easing: 'swing',
                step: function (now) {
                  $(this).text(Math.ceil(now));
                },
                complete: function () {
                  $(this).text(total);
                  $(this).removeClass('animate-once');
                },
              }
            );
        }
      });

      $('.absolute-image').each(function () {
        if (isScrolledIntoView(this) === true) {
          $(this).addClass('active');
        }
      });
    });

    function parallax() {
      $('.wp-block-cover.has-parallax, .parallax').each(function () {
        const scrollTop = $(window).scrollTop();
        const offset = $(this).offset().top;
        const marginTop = -(scrollTop - offset) * 0.7 - 150;
        $(this).css({
          'background-position-y': marginTop,
        });
      });

      $('.btn-enter-home').each(function () {
        const scrollTop = $(window).scrollTop();
        const offset = 500;
        let opacity = 1;
        let marginTop = 50;
        opacity = 1.5 - scrollTop / offset;
        marginTop = scrollTop * 0.55 + 50;
        $(this).css({
          top: marginTop,
          opacity: opacity,
        });
      });

      $('.wp-block-cover.has-parallax .wp-block-cover__inner-container').each(
        function () {
          const scrollTop = $(window).scrollTop();
          const offset = 500;
          let opacity = 1;
          let marginTop = 0;
          opacity = 1.5 - scrollTop / offset;
          marginTop = scrollTop * 0.4;

          $(this).css({
            top: marginTop,
            opacity: opacity,
            'padding-top': $('.banner').height(),
          });
        }
      );
    }

    const deviceAgent = navigator.userAgent.toLowerCase();
    const agentID = deviceAgent.match(/(iphone|ipod|ipad)/);

    // On scroll
    $(window).scroll(function () {
      if ($(window).width() > 992 && !agentID) {
        parallax();
      }
    });

    $(window).load(function () {
      if ($(window).width() > 992 && !agentID) {
        parallax();
      }
    });

    // Gallery popup
    $('.wp-block-gallery').magnificPopup({
      delegate: 'a',
      type: 'image',
      gallery: {
        enabled: true,
        tLoading: 'Loading image #%curr%...',
        navigateByImgClick: true,
        preload: [0, 1],
      },
    });

    // Magnific Popup
    $('.popup-youtube a').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,

      fixedContentPos: false,
    });

    // Cookie Consent
    window.addEventListener('load', function () {
      window.cookieconsent.initialise({
        palette: {
          popup: {
            background: '#000000',
          },
          button: {
            background: '#e13323',
          },
        },
        showLink: true,
        content: {
          href: 'https://' + window.location.hostname + '/race-rules#privacy',
        },
      });
    });

    // Updated Gallery classes based on window size
    const lg = window.matchMedia('(min-width: 991px)');
    const md = window.matchMedia('(min-width: 768px) and (max-width: 991px)');
    const sm = window.matchMedia('(max-width: 767px)');

    function smGallery() {
      $('.wp-block-gallery').addClass('columns-1');
      $('.wp-block-gallery').removeClass('columns-4');
      $('.wp-block-gallery').removeClass('columns-2');
    }

    function mdGallery() {
      $('.wp-block-gallery').addClass('columns-2');
      $('.wp-block-gallery').removeClass('columns-4');
      $('.wp-block-gallery').removeClass('columns-1');
    }

    function lgGallery() {
      $('.wp-block-gallery').addClass('columns-4');
      $('.wp-block-gallery').removeClass('columns-2');
      $('.wp-block-gallery').removeClass('columns-1');
    }

    if (sm.matches) {
      smGallery();
    } else if (md.matches) {
      mdGallery();
    } else {
      lgGallery();
    }

    lg.addListener(function (event) {
      if (event.matches) {
        lgGallery();
      }
    });
    md.addListener(function (event) {
      if (event.matches) {
        mdGallery();
      }
    });
    sm.addListener(function (event) {
      if (event.matches) {
        smGallery();
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    if (window.pageYOffset >= 100) {
      $('#hamburger').addClass('scrolled');
    } else {
      $('#hamburger').removeClass('scrolled');
    }

    /** When the user scrolls the page, execute header animation */
    window.addEventListener('scroll', function () {
      if (window.pageYOffset >= 100) {
        $('#hamburger').addClass('scrolled');
      } else {
        $('#hamburger').removeClass('scrolled');
      }
    });

    $('#event-slider').slick({
      arrows: false,
      dots: true,
      infinite: true,
      vertical: true,
      autoplay: true,
      autoplaySpeed: 5000,
    });

    $('.slides').slick({
      arrows: true,
      dots: false,
      infinite: true,
      prevArrow: $('#slidePrev'),
      nextArrow: $('#slideNext'),
      autoplay: true,
      autoplaySpeed: 5000,
    });

    $('.news-carousel').slick({
      arrows: true,
      dots: false,
      infinite: true,
      prevArrow: $('#newsPrev'),
      nextArrow: $('#newsNext'),
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js